import React from "react";
import { StyleProp, Text, TextStyle } from "react-native";

import { formatPhoneNumberDisplay } from "../../../utils/phoneNumber";

type PhoneNumberTextProps = {
  value?: string | null;
  fallback?: string;
  style?: StyleProp<TextStyle>;
  numberOfLines?: number;
};

const PhoneNumberText: React.FC<PhoneNumberTextProps> = ({
  value,
  fallback = "-",
  style,
  numberOfLines,
}) => {
  return (
    <Text style={style} numberOfLines={numberOfLines}>
      {formatPhoneNumberDisplay(value, { fallback })}
    </Text>
  );
};

export default PhoneNumberText;
